<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories" style="color:black">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">Районы</div>
                    </div>
                    <div class="region-map">
                      <div id="map" style="width: 100%; height: 1000px"></div>
                    </div>
                    <div class="head-panel indent-top visibility">
                      <router-link to="/directories/districts/new" style="color:black">
                        <div class="add-table-string"><i>+</i>Добавить район</div>
                      </router-link>
                    </div>
                    <table cellpadding="0" cellspacing="0" class="region-table">
                      <thead>
                      <tr>
                        <td>Наименование района</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr title="Редактировать" v-for="district in districts"
                          @click="$router.push('/directories/districts/' + district.id)">
                        <td class="name">{{district.name}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MenuDispatcher from '@/components/MenuDispatcher.vue'
  import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
  import api from '@/api'

  export default {
    name: 'Districts',
    components: { HeaderDispatcher, MenuDispatcher },

    data () {
      return {
        districts: {},
        map: {}
      }
    },

    created () {
      api
          .getDistricts()
          .then(districts => {
            if (districts) {
              this.districts = []
              this.districts = districts

              ymaps.ready(() => {
                require('@/utils/ymaps/calculateArea.min.js')
                require('@/utils/ymaps/polylabel.min.js')
                this.initDistrictsMap(this.districts)
              })
            }
          })
    },

    mounted () {
      let body = document.getElementsByTagName('body')[0]
      body.classList.add('cabinet-page')
    },

    destroyed () {
      let body = document.getElementsByTagName('body')[0]
      body.classList.remove('cabinet-page')
    },

    methods: {
      polygonColor(i) {
        let i7 = (i ? i : 0) % 7;
        let color;
        // В формате RGBA. Последние два разряда определяют уровень прозрачности (альфа-канал): 00 - полностью прозрачный, ff - непрозрачный.
        switch(i7) {
          case 0: color = 'ff005033'; break;
          case 1: color = 'ff940033'; break;
          case 2: color = 'd8ff0033'; break;
          case 3: color = '00ff7b33'; break;
          case 4: color = '00bfff33'; break;
          case 5: color = '6e00ff33'; break;
          case 6: color = 'ff00cb33'; break;
          default: color = 'ffffff33';
        }
        return color;
      },

      initDistrictsMap (districts) {
        let districtsForMap = []

        for (let i = 0; i < districts.length; i++) {
          districtsForMap.push(districts[i].points.reduce((l, x) => {
            l.push([x.lat, x.lng])
            return l
          }, []))
        }

        ymaps.ready(['polylabel.create']).then(() => {
              let map = new ymaps.Map('map', {
                    center: [55.796289, 49.108795],
                    zoom: 12,
                    controls: ['zoomControl', 'searchControl', 'fullscreenControl']
                  },
                  { suppressMapOpenBlock: true }
              )
              let districtsCollection = new ymaps.GeoObjectCollection()
              for (let i = 0; i < districts.length; i++) {
                let pol = new ymaps.GeoObject({
                  // Описываем геометрию геообъекта.
                  geometry: {
                    // Тип геометрии - "Многоугольник".
                    type: 'Polygon',
                    // Указываем координаты вершин многоугольника.
                    coordinates: [
                      // Координаты вершин внешнего контура.
                      districts[i].points.reduce((l, x) => {
                        l.push([x.lat, x.lng])
                        return l
                      }, [])
                    ]
                  },
                  properties: {
                    name: districts[i].name
                  }
                }, {
                  labelDefaults: 'light',
                  labelLayout: '<div style="font-size: 22px">{{properties.name}} район</div>',
                  // labelLayout: '',
                  // это не работает
                  labelTextSize: {
                    '0_4': 16,
                    '5_23': 22
                  },
                  fillColor: this.polygonColor(i)
                })

                districtsCollection.add(pol)
              }
              map.geoObjects.add(districtsCollection)
              const polylabel = new ymaps.polylabel.create(map, districtsCollection)
            }
        ).catch(e => {
          // элегантное решение для загрузки надписей на многоугольниках при повторном открытии окна "Регионы"
          // console.log(e)
          this.$router.go('/directories/districts')
        })
      }
    }
  }
</script>
